import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {AllRequestData} from '@api/common';
import {ScheduleVersion, ScheduleVersionEndpoint} from '@api/planner';

@Injectable()
export class ScheduleVersionListData extends AllRequestData<ScheduleVersion> {

  private scheduleId: number | null = null;

  constructor(private endpoint: ScheduleVersionEndpoint) {
    super();
  }

  setScheduleId(scheduleId: number): void {
    this.scheduleId = scheduleId;
  }

  getScheduleId(): number | null {
    return this.scheduleId;
  }

  protected getCall(): Observable<ScheduleVersion[]> {
    if (!this.scheduleId) {
      return throwError(() => new Error('Schedule ID not set'));
    }
    return this.endpoint.getAll(this.scheduleId);
  }
}
